<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">

    <template #cell(name)="data">
      <div class="">
        <img class="language-image" :src="data.item.image" v-if="data.item.image != null" :alt="data.item.name"/>
        <span class="text-wrap">{{ data.item.name }}</span>
      </div>
    </template>


    <template #cell(slug)="data">
      <span class="text-wrap">{{ data.item.slug }}</span>
    </template>


    <template #cell(action)="data">


      <div>


        <span v-b-modal="`update-language-${data.item.id}`" v-b-tooltip.hover title="ویرایش"
              class="mx-3  h5">
          <b-icon-pencil/>
        </span>


        <b-modal :id="`update-language-${data.item.id}`" size="xl" hide-footer>
          <div class="text-right">
            <LanguageForm :submit-function="updateLanguage" :language="data.item"/>
          </div>

        </b-modal>


        <span @click="deleteLanguage(data.item)" v-b-tooltip.hover title="حذف"
              class="mx-3  h5">
          <b-icon-trash/>
        </span>


      </div>

    </template>


  </b-table>
</template>
<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import LanguageForm from "./LanguageForm";
import {mapActions} from "vuex";

export default {
  name: "tableItemOfOrders",
  components: {LanguageForm},
  props: ["items"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "name", label: "نام"},
        {key: "slug", label: "slug"},
        {key: "action", label: ""},
      ],
    };
  },
  methods: {
    ...mapActions({
      updateLanguage: "Language/updateLanguage"
    }),
    deleteLanguage(item) {
      if (confirm('در صورت حذف ایتم های این زبان در حالت "نمایش همه" در دسترس خواهند بود')) {
        this.$store.dispatch('Language/deleteLanguage', item)
      }
    }
  },

};
</script>

<style scoped>
.language-image {
  object-fit: contain;
  width: 50px;
  height: 50px;
}

</style>